import { Truck, Package, FileCheck, Box, Warehouse, Sparkles, Trash2, Wrench } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const services = [
  {
    icon: Truck,
    title: 'Komplettumzug',
    description: 'Ein- & Auspackservice, professionelle Möbelmontage und kompletter Transport von Tür zu Tür.',
    link: '/komplettumzug',
  },
  {
    icon: Package,
    title: 'Teilumzug',
    description: 'Nur Möbeltransport oder Kisten – Sie entscheiden, wie viel Service Sie benötigen.',
    link: '/teilumzug',
  },
  {
    icon: FileCheck,
    title: 'Zollabwicklung & Formalitäten',
    description: 'Wir kümmern uns um alle Zollformalitäten und Dokumente für Ihren Grenzumzug.',
    link: '/zollabwicklung',
  },
  {
    icon: Box,
    title: 'Verpackungsmaterial & Kartons',
    description: 'Hochwertige Umzugskartons, Luftpolsterfolie und professionelles Verpackungsmaterial.',
    link: '/verpackungsmaterial',
  },
  {
    icon: Warehouse,
    title: 'Zwischenlagerung',
    description: 'Sichere Lagerung Ihrer Möbel in der Schweiz oder Deutschland – flexibel nach Bedarf.',
    link: '/zwischenlagerung',
  },
  {
    icon: Sparkles,
    title: 'Endreinigung',
    description: 'Professionelle Endreinigung Ihrer alten Wohnung für die Schlüsselübergabe.',
    link: '/endreinigung',
  },
  {
    icon: Trash2,
    title: 'Entsorgung',
    description: 'Fachgerechte Entsorgung von Möbeln und Hausrat, den Sie nicht mitnehmen möchten.',
    link: null,
  },
  {
    icon: Wrench,
    title: 'Möbellift & Spezialservice',
    description: 'Möbellift für schwierige Zugänge und Spezialtransport für Piano, Tresor & Kunst.',
    link: null,
  },
];

export default function Services() {
  const navigate = useNavigate();

  return (
    <section id="leistungen" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-slate-100 text-slate-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Umzugsfirma nach Deutschland - Unsere Leistungen
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Komplettservice für Ihren Umzug nach Deutschland
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Ihre Umzugsfirma für Umzug Schweiz Deutschland und Auswandern nach Deutschland – von der ersten Besichtigung bis zur Schlüsselübergabe begleiten wir Sie durch jeden Schritt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                onClick={() => service.link && navigate(service.link)}
                className={`bg-slate-50 hover:bg-white border-2 border-slate-100 hover:border-slate-800 rounded-xl p-6 transition-all duration-300 group hover:shadow-xl hover:-translate-y-2 ${service.link ? 'cursor-pointer' : ''}`}
              >
                <div className="bg-slate-800 group-hover:bg-slate-900 w-12 h-12 rounded-lg flex items-center justify-center mb-4 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-slate-800">
                  {service.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 relative bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 md:p-12 text-white overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <img
              src="/umzuege-schweiz-nach-deutschland.jpeg"
              alt="Umzugsteam lädt Möbel und Kartons in Umzugswagen für internationalen Transport Schweiz Deutschland"
              title="Internationale Umzüge Schweiz Deutschland - Komplettservice"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="relative z-10 grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-4">
                Spezialisiert auf Umzug nach Deutschland
              </h3>
              <p className="text-slate-200 leading-relaxed mb-6">
                Mit über 10 Jahren Erfahrung als Umzugsfirma nach Deutschland kennen wir alle Besonderheiten beim Umzug Schweiz Deutschland.
                Wir arbeiten eng mit Zollbehörden zusammen und garantieren einen reibungslosen Ablauf beim Auswandern nach Deutschland.
              </p>
              <div className="flex flex-wrap gap-3">
                <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium">
                  Zürich → München
                </div>
                <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium">
                  Basel → Berlin
                </div>
                <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium">
                  Bern → Hamburg
                </div>
                <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium">
                  Alle Routen
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-bold mb-2">500+</div>
                <div className="text-slate-200 text-sm">Umzüge pro Jahr</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-bold mb-2">98%</div>
                <div className="text-slate-200 text-sm">Zufriedenheit</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-bold mb-2">10+</div>
                <div className="text-slate-200 text-sm">Jahre Erfahrung</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-bold mb-2">24/7</div>
                <div className="text-slate-200 text-sm">Erreichbar</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
